import React__default from 'react';

var YouMayAlsoLikeArticle = function YouMayAlsoLikeArticle(props) {
  var article = props.article;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "flex flex-col",
    "automation-id": "YouMayAlsoLikeArticle-".concat(article.id)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "mb-2"
  }, /*#__PURE__*/React__default.createElement("img", {
    src: article.imageUrl
  })), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", {
    className: "font-serif text-p-16 leading-[22px]"
  }, article.title)));
};

export { YouMayAlsoLikeArticle };
//# sourceMappingURL=you-may-also-like-article.esm.js.map
